/**
 * usePageTitle — small effect that sets document.title per-page.
 * Pass just the page name (e.g. "Your Dashboard") and it becomes
 * "RoleIQ — Your Dashboard". Pass nothing to reset to brand default.
 */
import { useEffect } from "react";

const BRAND_DEFAULT = "RoleIQ — AI-Powered Intelligence";

export default function usePageTitle(pageName) {
  useEffect(() => {
    const t = pageName ? `RoleIQ — ${pageName}` : BRAND_DEFAULT;
    const prev = document.title;
    document.title = t;
    return () => {
      // Reset only if the next page hasn't already set its own
      if (document.title === t) document.title = BRAND_DEFAULT;
    };
  }, [pageName]);
}
